import app from 'apps/modules/app/AppReducer';
import quickshopweb from 'apps/modules/quickshopweb/QuickshopWebReducer';

import { combineReducers } from 'redux-immutable';

export default combineReducers({
  app,
  quickshopweb
});
